import { useAuthenticationInternal } from '@pflegenavi/frontend/authentication';
import { getGlobalServiceProviderIdFromToken } from '../utils/getGlobalServiceProviderIdFromToken';

export const useGetGlobalServiceProviderId = (): {
  globalServiceProviderId: string | undefined;
} => {
  const { getTokenImmediate } = useAuthenticationInternal();

  const globalServiceProviderId = getGlobalServiceProviderIdFromToken(
    getTokenImmediate()
  );

  return { globalServiceProviderId };
};
